import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[libTrim]',
  standalone: true
})
export class TrimDirective {

  constructor(private _el: ElementRef, private _ngControl: NgControl) { }

  @HostListener('blur', ['$event'])
  onBlur(event: KeyboardEvent) {
    this._ngControl.control?.setValue(this._el.nativeElement.value.trim())
    this._el.nativeElement.value = this._el.nativeElement.value.trim();
    
  }
}
